/**
 * Notification Service
 * Handles API calls for notifications
 */
import api from './index';

const notificationService = {
  /**
   * Get notifications for the current user
   * @param {object} options Query options
   * @returns {Promise<object>} Notifications response
   */
  async getNotifications(options = {}) {
    const params = new URLSearchParams();
    if (options.unreadOnly) params.append('unreadOnly', 'true');
    if (options.limit) params.append('limit', options.limit.toString());
    if (options.offset) params.append('offset', options.offset.toString());

    const queryString = params.toString();
    const url = queryString ? `/notifications?${queryString}` : '/notifications';

    const response = await api.get(url);
    return response.data;
  },

  /**
   * Get unread notification count
   * @returns {Promise<object>} Count response
   */
  async getUnreadCount() {
    const response = await api.get('/notifications/count');
    return response.data;
  },

  /**
   * Get a single notification by ID
   * @param {string} id Notification ID
   * @returns {Promise<object>} Notification
   */
  async getNotification(id) {
    const response = await api.get(`/notifications/${id}`);
    return response.data;
  },

  /**
   * Mark a notification as read
   * @param {string} id Notification ID
   * @returns {Promise<object>} Updated notification
   */
  async markAsRead(id) {
    const response = await api.patch(`/notifications/${id}`, {
      action: 'read'
    });
    return response.data;
  },

  /**
   * Mark all notifications as read
   * @returns {Promise<object>} Result
   */
  async markAllAsRead() {
    const response = await api.post('/notifications', {
      action: 'markAllRead'
    });
    return response.data;
  },

  /**
   * Dismiss a notification
   * @param {string} id Notification ID
   * @returns {Promise<object>} Updated notification
   */
  async dismiss(id) {
    const response = await api.patch(`/notifications/${id}`, {
      action: 'dismiss'
    });
    return response.data;
  }
};

export default notificationService;
